export default __webpack_public_path__ + "fd5b2870f047cc99192647d29531dcf2.webp";